import { View } from 'react-native'
import { TemplatePage } from '../../components/TemplatePage'
import { globalStyle } from '../../theme/global'
import { useContext, useEffect } from 'react'
import { MenuItem } from './components/MenuItem'
import {
  faEdit,
  faFish,
  faHouseFloodWaterCircleArrowRight,
} from '@fortawesome/free-solid-svg-icons'
import { StackNavigationProp } from '@react-navigation/stack'
import { useNavigation } from '@react-navigation/native'
import {
  ControlServiceRecord,
  Item,
  MortalityRecord,
  StateRecord,
} from '../../context/Alerts/types'
import { useTranslation } from 'react-i18next'
import { useUserPermissions } from '../../hooks/useUserPermissions'
import { useContextApp } from '../../hooks/useContextApp'
import { RootParams } from '../../navigator/types'
import { FuelContext } from '../../context/Logistics/fuel/FuelProvider'

interface Navigate extends StackNavigationProp<RootParams, 'Alerts'> {}

export const Alerts = () => {
  const {
    user: { areaSelected },
    getRecordsByArea,
  } = useContextApp()
  const { getFuelRecords } = useContext(FuelContext)

  const { t } = useTranslation()
  const { getPermissionsByAreaAndModule } = useUserPermissions()

  const mortalityRecords = getRecordsByArea({
    areaSelected,
    alertType: 'mortalityRecords',
    getArea: (item: Item<MortalityRecord>) => item.area,
    getRecord: (item: Item<MortalityRecord>) => item.record,
  })

  const stateRecords = getRecordsByArea({
    areaSelected,
    alertType: 'statesRecords',
    getArea: (item: Item<StateRecord>) => item.area,
    getRecord: (item: Item<StateRecord>) => item.record,
  })

  const controlServiceRecords = getRecordsByArea({
    areaSelected,
    alertType: 'controlServiceRecords',
    getArea: (item: Item<ControlServiceRecord>) => item.area,
    getRecord: (item: Item<ControlServiceRecord>) => item.record,
  })

  const uvFilterRecords = getRecordsByArea({
    areaSelected,
    alertType: 'uvFilters',
    getArea: (item: Item<StateRecord>) => item.area,
    getRecord: (item: Item<StateRecord>) => item.record,
  })

  const fuelRecords = getFuelRecords(areaSelected)

  const { navigate } = useNavigation<Navigate>()

  useEffect(() => {
    const isLogistic = areaSelected === 'logistic'
    if (
      stateRecords.length === 0 &&
      mortalityRecords.length === 0 &&
      controlServiceRecords.length === 0 &&
      uvFilterRecords.length === 0 &&
      !isLogistic
    ) {
      navigate('HomeScreen')
    }
  }, [stateRecords, mortalityRecords, controlServiceRecords, uvFilterRecords, areaSelected])

  return (
    <TemplatePage styleContent={{ padding: 0, marginBottom: 0 }} header title={t('Alertas')}>
      <View style={globalStyle.viewContainer}>
        {mortalityRecords.length > 0 && getPermissionsByAreaAndModule('mortality') && (
          <MenuItem
            amount={mortalityRecords.length}
            title={t('Mortalidad')}
            icon={faHouseFloodWaterCircleArrowRight}
            onPress={() => navigate('DetailMortality')}
          />
        )}

        {stateRecords.length > 0 && getPermissionsByAreaAndModule('states') && (
          <MenuItem
            amount={stateRecords.length}
            title={t('Estados')}
            icon={faFish}
            onPress={() => navigate('DetailStates')}
          />
        )}

        {uvFilterRecords.length > 0 && getPermissionsByAreaAndModule('uvfilters') && (
          <MenuItem
            amount={uvFilterRecords.length}
            title={t('Filtros UV')}
            icon={faFish}
            onPress={() => navigate('DetailUVFilters')}
          />
        )}

        {areaSelected === 'seaWater' &&
          controlServiceRecords.length > 0 &&
          getPermissionsByAreaAndModule('controlService') && (
            <MenuItem
              amount={controlServiceRecords.length}
              title={t('Control Services')}
              icon={faEdit}
              onPress={() => navigate('ControlServicesStack', { screen: 'DetailControlServices' })}
            />
          )}

        {areaSelected === 'logistic' && (
          <MenuItem
            amount={fuelRecords.length}
            title={t('Recepción combustible')}
            icon={faEdit}
            onPress={() => navigate('LogisticsStack', { screen: 'Records' })}
          />
        )}
      </View>
    </TemplatePage>
  )
}
